import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-8 pb-10 sm:pt-14 sm:pb-20 items-center justify-center overflow-hidden bg-bg-main" data-id="element-192">
      {/* Grid background */}
      <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" data-id="element-193"></div>

      {/* Orange glows */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[500px] rounded-full blur-[120px] pointer-events-none" style={{
      background: 'rgba(242, 92, 37, 0.18)'
    }} data-id="element-194"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full blur-[100px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(242, 92, 37, 0.12)'
    }} data-id="element-195"></div>

      {/* Top warning badge */}
      <div className="relative bg-primary/10 border border-primary/40 text-primary font-bold text-[10px] sm:text-xs uppercase px-3 py-1.5 sm:px-4 sm:py-2 rounded-sm mb-5 sm:mb-7 flex items-center gap-2 tracking-wider shadow-[0_0_20px_rgba(242,92,37,0.2)]" data-id="element-196">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-primary animate-pulse" data-id="element-197"></span>
        <span className="hidden sm:inline" data-id="element-198">
          🚨 COACHS FUNCTIONAL FATIGUÉS DE PASSER LEURS SOIRÉES À CRÉER DES
          SÉANCES ?
        </span>
        <span className="sm:hidden" data-id="element-199">🚨 ATTENTION COACHS FUNCTIONAL</span>
      </div>

      {/* Headline */}
      <h1 className="font-display relative font-bold max-w-5xl sm:text-6xl md:text-7xl mb-5 sm:mb-7 tracking-tight uppercase text-white text-[24px]" data-id="element-200">
        Résolvez des mois de classes Functional en{' '}
        <span className="text-primary relative inline-block" data-id="element-201">
          quelques minutes.
          <span className="absolute -bottom-1 left-0 w-full h-1 bg-primary" data-id="element-202"></span>
        </span>
      </h1>

      {/* Subheadline */}
      <p className="relative sm:text-xl font-medium mb-3 sm:mb-5 max-w-3xl mx-auto text-text-sec text-[12px]" data-id="element-203">
        Le système{' '}
        <span className="font-bold text-primary" data-id="element-204">"Ouvrir & Coacher"</span>{' '}
        utilisé par les coachs functional modernes pour créer des classes
        premium sans perdre des heures à programmer.
      </p>

      <p className="relative text-base sm:text-2xl font-bold text-white mb-6 sm:mb-10 max-w-2xl" data-id="element-205">
        Reprenez votre temps. Arrêtez d'improviser. Passez au niveau premium.
      </p>

      {/* Hero image */}
      <div className="relative w-full max-w-[260px] sm:max-w-[440px] md:max-w-[560px] mx-auto mb-4 sm:mb-6" data-id="element-206">
        <div className="absolute inset-0 blur-[80px] rounded-full hidden sm:block" style={{
        background: 'rgba(242, 92, 37, 0.25)'
      }} data-id="element-207"></div>
        <img src="https://cdn.magicpatterns.com/uploads/otZUE6bwwMqJ2pmyu6NFCm/francia.png" alt="FUNCTIONAL CLÉ EN MAIN — Le système complet avec 6 Bonus Premium pour Coachs Functional Modernes" className="relative w-full h-auto object-contain drop-shadow-[0_25px_45px_rgba(242,92,37,0.35)]" width={1200} height={800} fetchPriority="high" loading="eager" decoding="async" data-id="element-208" />
      </div>

      <p className="relative font-display uppercase font-bold text-sm sm:text-xl text-white tracking-widest mb-2" data-id="element-209">
        FUNCTIONAL CLÉ EN MAIN — LE SYSTÈME COMPLET
      </p>
      <p className="relative text-xs sm:text-sm text-text-sec mb-6 sm:mb-8 uppercase tracking-wider" data-id="element-210">
        Le système premium pour coachs functional modernes
      </p>

      {/* Reviews */}
      <div className="relative flex flex-col items-center gap-3 mb-5 sm:mb-7" data-id="element-211">
        <div className="flex items-center gap-2" data-id="element-212">
          <span className="text-sm sm:text-lg text-secondary" data-id="element-213">⭐⭐⭐⭐⭐</span>
          <span className="text-xs sm:text-base font-medium text-text-sec" data-id="element-214">
            4.9/5 (+1.200 Avis Vérifiés)
          </span>
        </div>
        <span className="font-bold text-xs sm:text-sm px-4 py-1.5 rounded-sm border border-primary/40 bg-primary/10 text-primary uppercase tracking-wider" data-id="element-215">
          🔥 87 coachs ont rejoint Functional Clé en Main aujourd'hui
        </span>
      </div>

      {/* CTA */}
      <a href="#pricing" onClick={() => {
      const w = window as any;
      if (w.fbq) {
        w.fbq('track', 'AddToCart', {
          content_name: 'Functional Clé en Main — Système Complet',
          content_type: 'product',
          value: 24,
          currency: 'EUR'
        });
      }
    }} className="relative btn-primary-pulse font-display font-bold uppercase tracking-wide text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-sm transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white bg-cta-green hover:bg-cta-green-hover border border-white/10" data-id="element-216">
        🚀 OUI ! JE VEUX FUNCTIONAL CLÉ EN MAIN
      </a>

      <p className="relative text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap text-text-sec uppercase tracking-wider" data-id="element-217">
        <span data-id="element-218">⚡ Accès Immédiat</span>
        <span data-id="element-219">•</span>
        <span data-id="element-220">🛡️ Garantie 7 Jours</span>
        <span data-id="element-221">•</span>
        <span data-id="element-222">💳 Paiement Unique</span>
      </p>
    </section>;
}